import { Button, Grid } from "antd";

import { Input } from "components/base";
import {useDispatch, useSelector} from "react-redux";
import { AppState } from "store";
import { archiveIcon, exportIcon, plusIcon, searchIcon } from "svgs";
import {useCallback, useEffect} from "react";
import {setClientSearch, setModalName} from "../../store/actions";
const { useBreakpoint } = Grid;

export default function ClientsHeader() {
    const dispatch = useDispatch();
      const screens = useBreakpoint();
  const { showbulkActionsClients } = useSelector<AppState, AppState["clients"]>(
    (state) => state.clients
  );
    const { userType } = useSelector<AppState, AppState["common"]>(
        (state) => state.common
    );
  // const { userType } = useSelector<AppState, AppState["common"]>(
  //   (state) => state.common
  // );

   const onChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
          dispatch(setClientSearch(event.target.value));
        },
        [dispatch]
      );
  
      useEffect(() => {
        dispatch(setClientSearch(""));
      }, [dispatch]);
    
      const searchValue = useSelector<AppState, string>(
        (state) => state.clients.search || ""
      );
    const onAddOrganization = useCallback(() => {
        dispatch(setModalName("add_organization"));
    }, [dispatch]);

       const isMobile = !screens.sm;
  return (
    <div className="common-header">
      <Input
        customClasses="--standard"
        placeholder="Search Clients..."
        prefix={searchIcon}
        value={searchValue}
        onChange={onChange}
      />
      {showbulkActionsClients && (
        <article className="bulk-actions">
          <Button disabled icon={exportIcon}>
            Export
          </Button>
          {/* <Button disabled danger icon={archiveIcon}>
            Archive
          </Button> */}
        </article>
      )}
          {isMobile && ( <h1 style={{ paddingTop: "6px", alignItems: "left" }}>Clients</h1>)}
        {(userType == 1 || userType == 2 || userType == 7) && <><div className="actions-container">
        <Button
          type="primary"
          onClick={onAddOrganization}
          icon={<span className="custom-icon">{plusIcon}</span>}>
          Add Client
        </Button>
      </div></>}
  
    </div>
  );
}
